module.exports = __webpack_public_path__ + "static/media/ProximaNova-SemiboldIt.f5e20c8d.eot";